module.exports = __webpack_public_path__ + "img/mainImg.482c3121.png";